import { styled } from '@mui/material/styles'
import { AppBar, Button, Toolbar } from '@mui/material'

export const ToolbarContent = styled(Toolbar)(({ theme }) => ({
  backgroundColor: theme.palette.commonColors.white,
  display: 'flex',
  color: theme.palette.commonColors.black,
  justifyContent: 'space-between',
}))

export const ToolbarArea = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  boxShadow: 'none',
  position: 'static',
  '.MuiToolbar-root': {
    minHeight: '55px',
  },
}))

export const ToolbarSaveBtn = styled(Button)`
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.commonColors.white};
  margin-right: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(0.5)};
  min-width: 55px;
  height: 35px;
  padding: 10px;
`
